import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { Lead } from 'pages/leadGen/LeadGenInterface';
import { formatWithCommaSeparator } from 'pages/tradeIn/TradeInUtils';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import TabLayout from 'sharedComponents/tab';
import { postLeadCreation } from 'store/LeadCreationState';
import { RootState } from 'store/store';
import { calculatePaymentsParams } from '../DigitalRetailingInterface';
import AllPaymentView from './sub-component/AllPaymentView';
import CashPaymentView from './sub-component/CashPaymentView';
import FinancePaymentView from './sub-component/FinancePaymentView';
import VehicleDetails from './sub-component/VehicleDetails';

const Step7: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);
  const { getValues } = useFormContext();

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth);
  const { vehicleData, paymentData } = useSelector((state: RootState) => state.digitalRetailingStore);

  const termData = authenticateClientData?.data?.widgetData?.term;
  const apr = authenticateClientData?.data?.widgetData?.apr;
  const widgetData = authenticateClientData?.data?.widgetData || {};

  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { downPayment, term, payType } = getValues();

    const paymentDetails: Lead = {
      leadDetails: {
        ...(term || termData ? { Term: `${term || termData} months` } : {}),
        ...(apr ? { APR: `${apr}%` } : {}),
        ...(downPayment ? { 'Down Payment': `$${formatWithCommaSeparator(downPayment)}` } : {}),
        ...(vehicleData?.MSR ? { MSRP: `$${formatWithCommaSeparator(vehicleData?.MSR)}` } : {}),
        ...(payType ? { 'Payment Type': payType } : {}),
        ...(paymentData?.monthly ? { 'Monthly Payment': `$${paymentData?.monthly?.toFixed(2)}` } : {}),
        ...(vehicleData?.VIN ? { VIN: vehicleData?.VIN } : {}),
      },
    };

    console.log('paymentDetails', paymentDetails);

    dispatch(postLeadCreation({ data: paymentDetails, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (res?.payload?.success && (res?.payload?.data?.draftLeadId || res?.payload?.data?._id)) {
        onNext?.();
      }
    });

    // onNext?.();
  };

  const backStep = () => {
    const { tradeInOption } = getValues();

    onBack?.(tradeInOption === 'Yes' ? 5 : 1);
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  const tabs = [
    {
      label: t('All'),
      content: (navigateToTab: (index: number) => void) => (
        <AllPaymentView
          navigateToTab={(data: calculatePaymentsParams, index: number) => {
            navigateToTab(index);
          }}
        />
      ),
      disabled: false,
    },
    {
      label: t('Cash'),
      content: () => <CashPaymentView />,
      // disabled: false,
    },
    {
      label: t('Finance'),
      content: () => <FinancePaymentView />,
      // disabled: true,
    },
  ];

  return (
    <div className='dr-widget-steps with-sidebar'>
      <div className='dr-widget-steps__content'>
        <h2 className='dr-widget-steps__title'>{t('digitalRetailing.paymentOptionHeading')}</h2>
        <p className='dr-widget-steps__step-note text-secondary'>{t('digitalRetailing.paymentOptionSubHeading')}</p>

        <TabLayout tabs={tabs} />
        <div className='dealer-send-note text-secondary mt-auto'>{t('stepperFormTradeIn.note4')}</div>
      </div>
      <VehicleDetails />
    </div>
  );
};

const StepperForm7 = React.forwardRef(Step7);

export default StepperForm7;
